import { KeepLearningCard as KeepLearningCardComponent } from "./KeepLearningCard.component";
import type { KeepLearningCardProps } from "./KeepLearningCard.types";
import * as KeepLearningCardVariants from "./KeepLearningCard.variants";

export const DefaultKeepLearningCard = ({ ...props }: Partial<KeepLearningCardProps>) => (
  <KeepLearningCardComponent { ...{ ...KeepLearningCardVariants.Default, ...props } }/>
);

export const KeepLearningCard = KeepLearningCardComponent;
